import type { GridApi, GridComparatorFn, GridGroupNode, GridSortDirection } from "@mui/x-data-grid-premium";
import type { RefObject } from "react";

interface GroupedNameRow {
  name: string;
  groupOrder: number;
}

const getGroupOrder = (api: GridApi, node: GridGroupNode): number => {
  const firstChildId = node.children[0];
  if (firstChildId === undefined) {
    return 0;
  }
  return api.getRow<GroupedNameRow>(firstChildId)?.groupOrder ?? 0;
};

export const getGroupedNameSortComparator =
  (apiRef: RefObject<GridApi | null>) =>
  (sortDirection: GridSortDirection): GridComparatorFn =>
  (_v1, _v2, cellParams1, cellParams2) => {
    const api = apiRef.current;
    if (!api) {
      return 0;
    }
    const node1 = cellParams1.rowNode;
    const node2 = cellParams2.rowNode;
    if (node1.type === "group" && node2.type === "group") {
      return getGroupOrder(api, node1) - getGroupOrder(api, node2);
    }
    const firstName = api.getRow<GroupedNameRow>(node1.id)?.name ?? "";
    const secondName = api.getRow<GroupedNameRow>(node2.id)?.name ?? "";
    const result = firstName.localeCompare(secondName);
    return sortDirection === "desc" ? -result : result;
  };
